module.exports = __webpack_public_path__ + "img/icon-resend.684f3b27.svg";